/** 仅保留数字 */
export function sanitizeDigits(value: string): string {
  return value.replace(/\D/g, '');
}

/** 座机：可选开头 +、数字与连字符 */
export function sanitizeTel(value: string): string {
  let out = '';
  for (const ch of value) {
    if (ch === '+' && out.length === 0) {
      out += ch;
      continue;
    }
    if (/[\d-]/.test(ch)) out += ch;
  }
  return out.replace(/-{2,}/g, '-');
}

/** 国际电话：可选 +、数字、空格、连字符 */
export function sanitizePhoneIntl(value: string): string {
  let out = '';
  for (const ch of value) {
    if (ch === '+' && out.length === 0) {
      out += ch;
      continue;
    }
    if (/[\d\s-]/.test(ch)) out += ch;
  }
  return out.replace(/-{2,}/g, '-').replace(/\s{2,}/g, ' ');
}

/**
 * 手机号完整校验（按区号区分常见地区位数）。
 * 与登录页逻辑保持一致。
 */
export function validateMobile(phone: string, areaCode = '+86'): boolean {
  const p = phone.trim();
  if (!p || !/^\d+$/.test(p)) return false;
  switch (areaCode) {
    case '+86':
      return /^1\d{10}$/.test(p);
    case '+852':
    case '+853':
      return p.length === 8;
    case '+886':
      return p.length === 9 || p.length === 10;
    case '+65':
      return p.length === 8;
    case '+1':
      return p.length === 10;
    default:
      return p.length >= 6 && p.length <= 15;
  }
}

/** 座机：大陆常见形态，或带可选国家码（开头 +） */
export function validateTel(value: string): boolean {
  const v = value.trim();
  if (v.startsWith('+')) {
    const rest = v.slice(1);
    if (!rest || !/^[\d-]+$/.test(rest) || rest.startsWith('-')) return false;
    const digits = rest.replace(/\D/g, '');
    return digits.length >= 6 && digits.length <= 15;
  }
  // 010-12345678 / 0755-1234567 / 400-xxx-xxxx 等宽松形态
  return /^(0\d{2,3}-?\d{7,8}|[48]00-?\d{3}-?\d{4}|\d{7,12})$/.test(v);
}

/** 国际号：含可选国家码，总数字位数 6–15 */
export function validatePhoneIntl(value: string): boolean {
  const digits = value.replace(/\D/g, '');
  return digits.length >= 6 && digits.length <= 15;
}

export function defaultMobileMaxLength(areaCode = '+86'): number {
  switch (areaCode) {
    case '+86':
      return 11;
    case '+852':
    case '+853':
    case '+65':
      return 8;
    case '+886':
      return 10;
    case '+1':
      return 10;
    default:
      return 15;
  }
}
